import { NavBar } from "../component/NavBar.jsx"
import { SideBar } from "../component/SideBar.jsx"

export const AdminManagerPage = ()=>{
    return (
        <div>
        <NavBar/>
        <SideBar selector="admin"/>
        <div className="container">
            <h1>Administrator</h1> 
            Admin manager content </div>
        
        </div>
    )
};